import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Constants } from '@app/common/constants';
import { MyAppTilesModule } from '@app/components/apps-and-tools/my-app-tiles/my-app-tiles.component';
import { MyDayModule } from '@app/components/my-day/my-day.component';
import { MyDocumentsModule } from '@app/components/my-documents/my-documents-widget/my-documents.component';
import { SmartLinksModule } from '@app/components/smart-links/smart-links.component';
import { PowerBIModule } from '@app/components/power-bi/power-bi.component';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { NgSubscribeModule } from '@app/directives/ng-subscribe.directive';
import { UserTabComponentConfiguration } from '@app/models/user-tab-configuration';
import { LinkModule } from '@app/directives/link.directive';
import { UserTabComponentConfigurationsService } from '@app/services/user-tab-config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-my-board',
  templateUrl: './my-board.component.html',
  styleUrls: ['./my-board.component.scss']
})
export class MyBoardComponent implements OnInit {

  tabConfig$: Observable<Array<UserTabComponentConfiguration>>;

  constructor(private router: Router, private userTabConfigService: UserTabComponentConfigurationsService) { }

  getTabConfigClassesForComponentId(componentId: string, normalPosition: number, userTabConfig: Array<UserTabComponentConfiguration>) {
    if (userTabConfig && userTabConfig.length > 0) {
      const conf = userTabConfig.find(u => u.ComponentId === componentId);
      if (conf) {
        if (conf.Hidden) {
          return 'd-none';
        }
        return `order-${conf.Order + 1}`;
      }
    }
    return `order-${normalPosition}`;
  }

  areAllComponentsTurnedOff(numberOfComponents: number, userTabConfig: Array<UserTabComponentConfiguration>) {
    if (userTabConfig && userTabConfig.length > 0) {
      const tabsForThisRoute = userTabConfig.filter(u => this.router.url.endsWith(u.TabId));
      if (tabsForThisRoute.length === numberOfComponents) {
        return tabsForThisRoute.every(u => u.Hidden === true);
      }
    }
    return false;
  }

  ngOnInit() {
    const configurableRoutes = this.router.config.filter(r => r.data && r.data[Constants.ROUTE_DATA_CONFIGURABLE_KEY] && '/' + r.path === this.router.url);

    if (configurableRoutes && configurableRoutes.length === 1) {
      this.tabConfig$ = this.userTabConfigService.getUserTabConfig()
        .pipe(
          map(result => {
            return result.filter(r => r.TabId === '/' + configurableRoutes[0].path);
          }));
    }
  }

}
@NgModule({
  declarations: [MyBoardComponent],
  exports: [MyBoardComponent],
  imports: [
    CommonModule,
    LinkModule,
    MyAppTilesModule,
    SmartLinksModule,
    MyDayModule,
    MyDocumentsModule,
    HideParentIfEmptyModule,
    MarkComponentVisitedModule,
    NgSubscribeModule,
    RouterModule,
    PowerBIModule
  ]
})
export class MyBoardModule { }
